var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"naef-mentions"},[_c('p',[_vm._v("© "+_vm._s(_vm.annee)+" naef.ch, Tous droits réservés.")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{attrs:{"href":"https://www.naef.ch/protection-des-donnees/","target":"_blank","rel":"noopener"}},[_vm._v("Protection des données")])])
}]

export { render, staticRenderFns }